module.exports = __webpack_public_path__ + "static/BundesSans-Web-Regular-7d6f994adbbe697a5219c83d5a23f0b5.woff";